module.exports = __webpack_public_path__ + "img/bird-house.dbbe2634.svg";